import React from 'react';

function MetricDisplay({
  label,
  value,
  unit = '',
  nationalAvg,
  lowerIsBetter = true,
  precision = 1,
  showChange = false,
  changeValue = null
}) {
  // Format value
  const formatValue = (val) => {
    if (val === null || val === undefined) return 'N/A';
    return typeof val === 'number' ? val.toFixed(precision) : val;
  };

  // Calculate comparison
  const getComparison = () => {
    if (value === null || value === undefined || nationalAvg === null || nationalAvg === undefined) {
      return null;
    }

    const diff = value - nationalAvg;
    const percentDiff = (diff / nationalAvg) * 100;

    let isGood;
    if (lowerIsBetter) {
      isGood = diff < 0;
    } else {
      isGood = diff > 0;
    }

    return {
      diff: diff.toFixed(precision),
      percentDiff: Math.abs(percentDiff).toFixed(1),
      isGood,
      label: isGood ? 'better' : 'worse'
    };
  };

  const comparison = getComparison();
  const hasValue = value !== null && value !== undefined;

  return (
    <div className="py-2">
      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-600">{label}</span>
        <div className="flex items-center space-x-2">
          <span className={`font-semibold ${hasValue ? 'text-gray-900' : 'text-gray-400'}`}>
            {formatValue(value)}{hasValue && unit}
          </span>

          {/* Comparison badge */}
          {comparison && (
            <span
              className={`text-xs px-2 py-0.5 rounded-full ${
                comparison.isGood
                  ? 'bg-green-100 text-green-700'
                  : 'bg-red-100 text-red-700'
              }`}
            >
              {comparison.percentDiff}% {comparison.label}
            </span>
          )}
        </div>
      </div>

      {/* National average reference */}
      {nationalAvg !== null && nationalAvg !== undefined && hasValue && (
        <div className="mt-1 text-xs text-gray-400">
          National avg: {formatValue(nationalAvg)}{unit}
        </div>
      )}

      {/* Change indicator */}
      {showChange && changeValue !== null && changeValue !== undefined && (
        <div className="mt-1 flex items-center text-xs">
          <span className={changeValue > 0 ? 'text-red-500' : 'text-green-500'}>
            {changeValue > 0 ? '+' : ''}{changeValue.toFixed(1)}%
          </span>
          <span className="text-gray-400 ml-1">vs last year</span>
        </div>
      )}
    </div>
  );
}

export default MetricDisplay;
